module.exports = __webpack_public_path__ + "img/hohlschnitt_hellgrau_farbnummer705.b02dd9cf.jpg";